const VALID_DDDS = new Set([
  "11","12","13","14","15","16","17","18","19",
  "21","22","24","27","28",
  "31","32","33","34","35","37","38",
  "41","42","43","44","45","46","47","48","49",
  "51","53","54","55",
  "61","62","63","64","65","66","67","68","69",
  "71","73","74","75","77","79",
  "81","82","83","84","85","86","87","88","89",
  "91","92","93","94","95","96","97","98","99"
])

const MOBILE_LENGTH = 11
const MOBILE_PREFIX = "9"

function onlyDigits(phone) {
  return (phone || "").replace(/\D/g, "")
}

function hasValidLength(digits) {
  return digits.length === MOBILE_LENGTH
}

function hasValidDDD(digits) {
  return VALID_DDDS.has(digits.substring(0, 2))
}

function hasMobilePrefix(digits) {
  return digits.charAt(2) === MOBILE_PREFIX
}

function hasAllRepeatedDigits(numero) {
  return /^(\d)\1+$/.test(numero)
}

function isSequential(numero) {
  const diffs = Array.from({ length: numero.length - 1 }, (_, i) =>
    parseInt(numero[i + 1]) - parseInt(numero[i])
  )
  return diffs.every(d => d === 1) || diffs.every(d => d === -1)
}

function isObviouslyFake(numero) {
  return hasAllRepeatedDigits(numero) || isSequential(numero)
}

export default function validatePhone(phone) {
  const digits = onlyDigits(phone)

  if (!hasValidLength(digits))  return "Número de celular incompleto. Informe DDD + número."
  if (!hasValidDDD(digits))     return "DDD inválido. Verifique o código de área informado."
  if (!hasMobilePrefix(digits)) return "Número de celular inválido. Celulares devem começar com 9 após o DDD."
  if (isObviouslyFake(digits.substring(3))) return "Número de telefone inválido."

  return null
}
